export default {
    refresh_devices_config_title: "Refresh Devices Config",
    refresh_devices_config_question: "Do you want to refresh the devices config?",
    refresh_devices_config_refresh: "Refresh",
    refresh_devices_config_success_message: "The refresh of the devices config has been started",
}